<template lang="pug">
  section.fifty-fifty
    .fifty-fifty__wrapper
      .fifty-fifty__column.fifty-fifty__column--media(
        :class="[mediaAligment, mediaWidth]"
      )
        .embed(
          v-if="videoId && videoType"
          :class="videoRatio"
        )
          iframe(
            :src="videoType == 'youtube' ? `https://www.youtube.com/embed/${videoId}` : `https://player.vimeo.com/video/${videoId}`"
          )
        img.fifty-fifty__image(
          v-else
          :src="imageSrc"
          :alt="imageAlt"
        )
      .fifty-fifty__column.fifty-fifty__column--copy
        h2(
          v-if="sectionTitle"
        ) {{ sectionTitle }}
        div(
          v-html="bodyCopy"
        ) {{ bodyCopy }}
        a.fifty-fifty__button.button(
          v-if="ctaUrl && ctaText"
          :href="ctaUrl"
          :title="ctaText"
      ) {{ ctaText }}
</template>

<script>
  export default {
    name: 'FiftyFifty',
    props: {
      desktopImage: String,
      mobileImage: String,
      imageAlt: String,
      mediaAligment: String,
      mediaWidth: String,
      videoId: String,
      videoType: String,
      videoRatio: String,
      sectionTitle: String,
      bodyCopy: String,
      ctaUrl: String,
      ctaText: String,
    },
    computed: {
      imageSrc() {
        return ['mobile', 'tablet'].includes(this.$mq) ? this.mobileImage : this.desktopImage;
      },
    },
  };
</script>

<style lang="scss">
  .fifty-fifty {
    padding-top: $spacing-unit * 7;
    padding-bottom: $spacing-unit * 7;
  }

  .fifty-fifty__wrapper {
    display: flex;
    flex-direction: column;
    padding-right: $grid-gutter-mobile;
    padding-left: $grid-gutter-mobile;
    max-width: $container-max-width;

    @include tablet-up {
      padding-right: $grid-gutter;
      padding-left: $grid-gutter;
      align-items: center;
      flex-direction: row;
      flex-wrap: nowrap;
    }
  }

  .fifty-fifty__column {
    padding: 0 $grid-gutter-mobile;
    flex: 0 0 1;
  }

  .fifty-fifty__column--40 {
    @include tablet-up {
      flex: 0 0 40%;
    }
  }

  .fifty-fifty__column--50 {
    @include tablet-up {
      flex: 0 0 50%;
    }
  }

  .fifty-fifty__column--60 {
    @include tablet-up {
      flex: 0 0 60%;
    }
  }

  .fifty-fifty__column--70 {
    @include tablet-up {
      flex: 0 0 70%;
    }
  }

  .fifty-fifty__column--left,
  .fifty-fifty__column--right {
    order: 1;
  }

  .fifty-fifty__column--right {
    @include tablet-up {
      order: 3;
    }
  }

  .fifty-fifty__column--media {
    margin-bottom: $spacing-unit * 8;

    @include tablet-up {
      margin-bottom: 0;
    }
  }

  .fifty-fifty__column--copy {
    order: 2;
  }

  .fifty-fifty__image {
    display: block;
    width: 100%;
  }

  .fifty-fifty__button {
    margin-top: $spacing-unit * 8;
  }
</style>
